module.exports = __webpack_public_path__ + "static/dashboard_report3@2x-067255e00e033bfd6936975207cbf84c.png";